export const PaymentMethods = {
  DebitOrder: [
    'za_capitec_bank',
    'za_fnb_bank',
    'za_africanbank_bank',
    'za_absa_bank',
    'za_standard_bank',
    'za_nedbank_bank',
    'za_investec_bank',
    'za_bidvestbank_bank',
    'za_tymebank_bank',
  ],
  CreditCard: ['en_visa_card', 'en_mastercard_card'],
};
